import { useHits } from "react-instantsearch";
import PaletteCard from "../PaletteCard/PaletteCard";
import { AlgoliaPaletteHit } from "../../types/AlgoliaTypes";
import { PLACEHOLDER_IMAGE } from "../../data/constants";

export default function PaletteHits() {

    const { hits } = useHits<AlgoliaPaletteHit>();
    
    return (
        <div className={"pallete-card__list"}>
                    {
                        hits.map((palette) => {
                            return (
                                <PaletteCard 
                                    key={palette.objectID} 
                                    id={palette.objectID}
                                    title={palette.name} 
                                    description={palette.description} 
                                    imageURL={palette.assetRelationships 
                                                && palette.assetRelationships[0] 
                                                ? palette.assetRelationships[0]
                                                : PLACEHOLDER_IMAGE}
                                    altText={palette.name}
                                    postLink={palette.name.replace(/^\s+|\s+$/gm,'-')}
                                    routerValue={palette.routerValue}
                                />
                            )
                        })
                    }
        </div>
    )
}